import { CommonModule } from "@angular/common";
import { Component, inject, Input, OnInit } from "@angular/core";
import { FormsModule } from "@angular/forms";
import { NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";
import _ from "lodash";
import * as uuid from "uuid";
import { formParamTableColumns } from "../../../core/table-templates/form-data-param";
import { encodedTableColumns } from "../../../core/table-templates/form-encoded-param";
import { ZorroTableComponent } from "../../common/custom-table/zorro-table.component";

@Component({
  selector: "app-add-payload-param-modal",
  standalone: true,
  imports: [CommonModule, FormsModule, ZorroTableComponent],
  templateUrl: "./add-payload-param-modal.component.html",
  styleUrl: "./add-payload-param-modal.component.scss",
})
export class AddPayloadParamModalComponent implements OnInit {
  isActive: boolean = false;

  activeModal = inject(NgbActiveModal);

  @Input()
  model: any;

  paramType: string = "FORM_DATA";
  tableData: any = {
    "FORM_DATA": {
      columns: formParamTableColumns,
      rows: [],
    },
    "X_WWW_FORM_URL_ENCODED": {
      columns: encodedTableColumns,
      rows: [],
    },
  };
  clonedData: any = {};
  contentType: string = "APPLICATION_FORM_URLENCODED";


  ngOnInit(): void {
    if(this.model){
      this.paramType = this.model?.payloadType ? this.model?.payloadType : this.model?.type;
      this.contentType = this.model?.contentType ? this.model?.contentType : this.model?.type;
      this.tableData[this.paramType].rows.push({
        key: this.model?.name,
        type: this.model?.type == "FORM_TEXT" ? "text" : (this.model?.type == "FORM_FILE" ? "file" : null),
        isRowEditable: true,
        isDraft: true,
      });
      
    }
  }


  handleTableActions(event: any) {
    switch (event.actionType) {
      case "add":
        if (event?.data?.row?.key && event?.data?.row?.isDraft) {
          const obj = {
            ...this.tableData[this.paramType].rows[0],
            isRowEditable: false,
            isDraft: false,
            id: uuid.v4(),
          };
          this.tableData[this.paramType].rows.shift();
          this.tableData[this.paramType].rows = [
            obj,
            ...this.tableData[this.paramType].rows,
          ];
          this.clonedData[this.paramType] = _.cloneDeep(
            this.tableData[this.paramType].rows
          );
        } else {
          this.tableData[this.paramType].rows = this.tableData[
            this.paramType
          ].rows.map((row: any) => {
            if (row.id === event.data.row.id) {
              return {
                ...row,
                isDraft: false,
                isRowEditable: false,
              };
            }
            return row;
          });
          this.clonedData[this.paramType] = _.cloneDeep(
            this.tableData[this.paramType].rows
          );
        }
        break;
      case "edit":
        if (event?.data?.row?.id) {
          this.tableData[this.paramType].rows = this.tableData[
            this.paramType
          ].rows.map((row: any) => {
            if (row.id === event.data.row.id) {
              return {
                ...row,
                isRowEditable: true,
              };
            }
            return row;
          });
        }
        break;
      case "cancel":
        if (event?.data?.row?.isDraft) {
          this.tableData[this.paramType].rows.shift();
          this.tableData[this.paramType].rows = [
            ...this.tableData[this.paramType].rows,
          ];
        } else {
          let objIndx = this.tableData[this.paramType].rows.findIndex(
            (row: any) => row.id === event.data.row.id
          );
          this.tableData[this.paramType].rows[objIndx] = this.clonedData[
            this.paramType
          ].find((ele: any) => ele.id === event.data.row.id);
          this.tableData[this.paramType].rows = [
            ...this.tableData[this.paramType].rows,
          ];
        }
        break;
      case "delete":
        if (event?.data?.row?.id) {
          let ind = this.tableData[this.paramType].rows.findIndex(
            (ele: any) => ele.id === event.data.row.id
          );
          this.tableData[this.paramType].rows.splice(ind, 1);
          this.tableData[this.paramType].rows = [
            ...this.tableData[this.paramType].rows,
          ];
          this.clonedData[this.paramType] = _.cloneDeep(
            this.tableData[this.paramType].rows
          );
        }
        break;
    }
  }

  addNew() {
    const obj = {
      key: "",
      type: "text",
      isRowEditable: true,
      isDraft: true,
    };
    this.tableData[this.paramType].rows = [
      obj,
      ...this.tableData[this.paramType].rows,
    ];
  }

  save() {
    let data;
    if (this.paramType === "RAW") {
      data = {
        payloadType: "RAW",
        contentType: this.contentType,
      };
    } else {
      data = {
        payloadType: this.paramType,
        contentType: this.tableData[this.paramType].rows,
      };
    }

    this.activeModal.close(data);
  }
}
